type CoordinateType = "lat" | "lng";

export const convertDecimalCoordinateToDegrees = (
  decimal: number,
  type: CoordinateType
) => {
  var sign = 1,
    Abs = 0;
  var days, minutes, secounds, direction;

  if (decimal < 0) {
    sign = -1;
  }

  Abs = Math.abs(Math.round(decimal * 1000000));

  if (type === "lat" && Abs > 90 * 1000000) {
    return null;
  } else if (type === "lng" && Abs > 180 * 1000000) {
    return null;
  }

  days = Math.floor(Abs / 1000000);
  minutes = Math.floor((Abs / 1000000 - days) * 60);
  secounds = (
    (Math.floor(((Abs / 1000000 - days) * 60 - minutes) * 100000) * 60) /
    100000
  ).toFixed();

  days = days * sign;

  if (type === "lat") {
    direction = days < 0 ? "S" : "N";
  } else {
    direction = days < 0 ? "W" : "E";
  }

  return days * sign + "º" + minutes + "'" + secounds + "''" + direction;
};
